const ProjectData=[

    {
      sourceimg:"edie.png",
        caption:"#HTML #CSS #BOOTSTRAP #RESPONSIVE #DEV CHALLENGE",
    

        title:"Edie Home Page",
        description:" In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
        demolink:"https://subtle-cendol-9902d3.netlify.app/",
        codelink:"https://github.com/MUSSAFARA-RIAZ/HomePage"

    },
    {
      sourceimg:"list.png",
        caption:"#HTML #CSS #BOOTSTRAP #RESPONSIVE #DEV CHALLENGE",
        title:"TO DO LIST",
        description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
        demolink:"https://mussafara-riaz.github.io/30-Days-OF-JS-project1/",
        codelink:"https://github.com/MUSSAFARA-RIAZ/30DaysOfJS_Project2-Grade-Calculator" 

    },
    {
      sourceimg:"calculator.png",
       caption:"#HTML #CSS #BOOTSTRAP #RESPONSIVE #DEV CHALLENGE",
           title:"Grade Calculator",
           description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
           demolink:"https://mussafara-riaz.github.io/30DaysOfJS_Project2-Grade-Calculator/",
           codelink:"https://github.com/MUSSAFARA-RIAZ/30DaysOfJS_Project2-Grade-Calculator"
    }
 
 ,{
   sourceimg:"ecommerce.png",
    caption:"#HTML #CSS #BOOTSTRAP #RESPONSIVE #FRONT-END MENTOR CHALLENGE",
        title:"Ecommerce Product Page",
        description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
        demolink:"",
        codelink:"https://github.com/MUSSAFARA-RIAZ/Ecommerce-Page"
 },{
   sourceimg:"google.png",
    caption:"#REACT CHALLENGE",
    title:"Google Keep App Clone",
    description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
    demolink:"",
    codelink:"https://github.com/MUSSAFARA-RIAZ/Google-Keep-App-Clone"

 },{
   sourceimg:"quote1.png",
    caption:"#JS CHALLENGE",
    title:"RANDOM QUOTE GENERATOR",
    description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
    demolink:"https://mussafara-riaz.github.io/Random-quote-Generator/",
    codelink:"https://github.com/MUSSAFARA-RIAZ/Random-quote-Generator"
 },
 {
   sourceimg:"meme.png",
    caption:"#REACT CHALLENGE",
    title:"MEME GENERATOR",
    description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
    demolink:"",
  codelink:"https://github.com/MUSSAFARA-RIAZ/Meme-Generator"

 },
 {
   sourceimg:"survey.png",
    caption:"#REACT CHALLENGE",
    title:"SURVEY FORM",
    description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
    demolink:"https://zingy-clafoutis-7507cc.netlify.app/",
  codelink:"https://github.com/MUSSAFARA-RIAZ/Surveyform"

 },
 {
   sourceimg:"checkout.png",
   caption:"#REACT CHALLENGE",
   title:"CHECKOUT PAGE CHALLENGE",
   description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
   demolink:"https://mussafara-riaz.github.io/Checkout-page-Challenge/",
 codelink:"https://github.com/MUSSAFARA-RIAZ/Checkout-page-Challenge"

},
{
  sourceimg:"animated.png",
  caption:"#REACT CHALLENGE",
  title:"ANIMATED WEBSITE",
  description:"In this project I worked with HTML and CSS (used CSS Grid Property only to create this responsive page. This page issimilar to the design provided as challenge by devChallenges",
  demolink:"https://delicate-dieffenbachia-31bf9c.netlify.app",
codelink:"https://github.com/MUSSAFARA-RIAZ/Animated-ReactWeb"

},

{
  sourceimg:"weather.png",
  caption:"#REACT CHALLENGE #API FETCHING",
  title:"WEATHER APP",
  description:"Build a Weather Application using the open weather Api",
  demolink:"",
codelink:""

},
{
  sourceimg:"qui.png",
  caption:"#HTML #CSS #JS CHALLENGE",
  title:"QUIZ APPLICATION",
  description:"Build a Weather Application using the open weather Api",
  demolink:"https://mussafara-riaz.github.io/30DaysOfJs-Project-3-Quiz-App/",
codelink:"https://github.com/MUSSAFARA-RIAZ/30DaysOfJs-Project-3-Quiz-App"

}
]
export default ProjectData;